import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import PageHeader from "components/common/PageHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Scheduling = () => {

    useEffect(() => {
        document.title = `Scheduling`
    }, [])

    return (<>
        <PageHeader
            title="Scheduling"
            description="Order scheduling management"
            className="mb-3"
        />
    </>)
}

export default Scheduling